import Home from "./Home";
import ImagePredection from "./ImagePredection";
import Disease from "./Diseases";
import HealthPrawn from "./HealthPrawn";
import Footer from "./Footer";

import "./App.css";

function App() {
  return (
    <div>
      <Home />
      <ImagePredection />
      <Disease />
      <HealthPrawn />
      <Footer />
    </div>
  );
}

export default App;
